import React from 'react';
import { PillButton } from '../PillButton';
import { useBeats } from '../../hooks/useBeats';
import { TOTAL_SECONDS, exchange } from '../../data/teaser';
const BEATS = [400, 1200, 1900, 2400, 2600, 2800, 3000, 3500];
interface ScreenBonusProps {
  /** Real seconds of attention given to the story. */
  secondsSpent: number;
}
export function ScreenBonus({
  secondsSpent
}: ScreenBonusProps) {
  const beat = useBeats(BEATS);
  const overrun = Math.max(0, secondsSpent - TOTAL_SECONDS);
  const rows = [{
    label: `${Math.max(secondsSpent, 1)} seconds`,
    detail: 'invested'
  }, ...exchange.slice(1)];
  return <section className="flex h-full w-full flex-col justify-center" data-id="element-109" data-mp="2zt03qwuwnq4k">
      <p className={`font-body text-[13px] text-white/50 transition-opacity duration-300 ease-out ${beat >= 1 ? 'opacity-100' : 'opacity-0'}`} data-id="element-110" data-mp="33ta7e2v864g9">
        And while we’re at it…
      </p>

      <div className={`mt-4 transition-[opacity,transform] duration-300 ease-out ${beat >= 2 ? 'scale-100 opacity-100' : 'scale-[0.97] opacity-0'}`} data-id="element-111" data-mp="19er8ea9w6j2z">
        <p className="font-headline text-[64px] font-extrabold leading-none tabular-nums text-solventum-primary" data-id="element-112" data-mp="1wf5iqyqvsvmu">
          12
        </p>
        <p className="mt-1 font-headline text-[26px] font-extrabold uppercase leading-none tracking-[0.1em] text-white" data-id="element-113" data-mp="1rh3ywblmssab">
          Minutes back
        </p>
      </div>

      <p className={`mt-3 font-body text-[13px] leading-relaxed text-white/50 transition-opacity duration-300 ease-out ${beat >= 3 ? 'opacity-100' : 'opacity-0'}`} data-id="element-114" data-mp="2k5jg94s8jmot">
        saved per bonding procedure, on average
      </p>

      <p className={`mt-7 border-t border-white/10 pt-5 font-body text-[13px] leading-relaxed text-white/45 transition-opacity duration-300 ease-out ${beat >= 4 ? 'opacity-100' : 'opacity-0'}`} data-id="element-115" data-mp="2a8wwkjbnb1od">
        {overrun > 2 ? `That took you ${secondsSpent} seconds — a little longer than we asked for. Worth it, we think.` : `That took you ${Math.max(secondsSpent, 1)} seconds. Right on the contract.`}
      </p>

      <dl className="mt-4" data-id="element-116" data-mp="3lz30ddxlqe59">
        {rows.map((row, index) => <div key={row.label} className={`flex items-baseline gap-2 py-0.5 transition-[opacity,transform] duration-300 ease-out ${beat >= index + 5 ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0'}`} data-id="element-117" data-mp="3814msar3ulqt" data-mpi={index}>
            <dt className="font-headline text-[15px] font-extrabold text-solventum-primary" data-id="element-118" data-mp="331ryrmohz8mn">
              {row.label}
            </dt>
            <dd className="font-body text-[13px] text-white/55" data-id="element-119" data-mp="2pbyap6ktgsdz">{row.detail}</dd>
          </div>)}
      </dl>

      <div className={`mt-8 flex items-center gap-3 transition-[opacity,transform] duration-300 ease-out ${beat >= 8 ? 'translate-y-0 opacity-100' : 'translate-y-1.5 opacity-0'}`} data-id="element-120" data-mp="2u73rjqzd3gv7">
        <PillButton variant="solid" size="md" data-id="element-121" data-mp="20p8s9jwly13x">
          See Precision Grip
        </PillButton>
      </div>
    </section>;
}